"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusCodeOK = 0x0;
exports.StatusCodeUncertain = 0x40000000;
exports.StatusCodeBad = 0x80000000;
exports.StatusCodeBadUnexpectedError = 0x80010000;
exports.StatusCodeBadInternalError = 0x80020000;
exports.StatusCodeBadOutOfMemory = 0x80030000;
exports.StatusCodeBadResourceUnavailable = 0x80040000;
exports.StatusCodeBadCommunicationError = 0x80050000;
exports.StatusCodeBadEncodingError = 0x80060000;
exports.StatusCodeBadDecodingError = 0x80070000;
exports.StatusCodeBadEncodingLimitsExceeded = 0x80080000;
exports.StatusCodeBadRequestTooLarge = 0x80b80000;
exports.StatusCodeBadResponseTooLarge = 0x80b90000;
exports.StatusCodeBadUnknownResponse = 0x80090000;
exports.StatusCodeBadTimeout = 0x800a0000;
exports.StatusCodeBadServiceUnsupported = 0x800b0000;
exports.StatusCodeBadShutdown = 0x800c0000;
exports.StatusCodeBadServerNotConnected = 0x800d0000;
exports.StatusCodeBadServerHalted = 0x800e0000;
exports.StatusCodeBadNothingToDo = 0x800f0000;
exports.StatusCodeBadTooManyOperations = 0x80100000;
exports.StatusCodeBadTooManyMonitoredItems = 0x80db0000;
exports.StatusCodeBadDataTypeIdUnknown = 0x80110000;
exports.StatusCodeBadCertificateInvalid = 0x80120000;
exports.StatusCodeBadSecurityChecksFailed = 0x80130000;
exports.StatusCodeBadCertificatePolicyCheckFailed = 0x81140000;
exports.StatusCodeBadCertificateTimeInvalid = 0x80140000;
exports.StatusCodeBadCertificateIssuerTimeInvalid = 0x80150000;
exports.StatusCodeBadCertificateHostNameInvalid = 0x80160000;
exports.StatusCodeBadCertificateUriInvalid = 0x80170000;
exports.StatusCodeBadCertificateUseNotAllowed = 0x80180000;
exports.StatusCodeBadCertificateIssuerUseNotAllowed = 0x80190000;
exports.StatusCodeBadCertificateUntrusted = 0x801a0000;
exports.StatusCodeBadCertificateRevocationUnknown = 0x801b0000;
exports.StatusCodeBadCertificateIssuerRevocationUnknown = 0x801c0000;
exports.StatusCodeBadCertificateRevoked = 0x801d0000;
exports.StatusCodeBadCertificateIssuerRevoked = 0x801e0000;
exports.StatusCodeBadCertificateChainIncomplete = 0x810d0000;
exports.StatusCodeBadUserAccessDenied = 0x801f0000;
exports.StatusCodeBadIdentityTokenInvalid = 0x80200000;
exports.StatusCodeBadIdentityTokenRejected = 0x80210000;
exports.StatusCodeBadSecureChannelIdInvalid = 0x80220000;
exports.StatusCodeBadInvalidTimestamp = 0x80230000;
exports.StatusCodeBadNonceInvalid = 0x80240000;
exports.StatusCodeBadSessionIdInvalid = 0x80250000;
exports.StatusCodeBadSessionClosed = 0x80260000;
exports.StatusCodeBadSessionNotActivated = 0x80270000;
exports.StatusCodeBadSubscriptionIdInvalid = 0x80280000;
exports.StatusCodeBadRequestHeaderInvalid = 0x802a0000;
exports.StatusCodeBadTimestampsToReturnInvalid = 0x802b0000;
exports.StatusCodeBadRequestCancelledByClient = 0x802c0000;
exports.StatusCodeBadTooManyArguments = 0x80e50000;
exports.StatusCodeBadLicenseExpired = 0x810e0000;
exports.StatusCodeBadLicenseLimitsExceeded = 0x810f0000;
exports.StatusCodeBadLicenseNotAvailable = 0x81100000;
exports.StatusCodeGoodSubscriptionTransferred = 0x002d0000;
exports.StatusCodeGoodCompletesAsynchronously = 0x002e0000;
exports.StatusCodeGoodOverload = 0x002f0000;
exports.StatusCodeGoodClamped = 0x00300000;
exports.StatusCodeBadNoCommunication = 0x80310000;
exports.StatusCodeBadWaitingForInitialData = 0x80320000;
exports.StatusCodeBadNodeIdInvalid = 0x80330000;
exports.StatusCodeBadNodeIdUnknown = 0x80340000;
exports.StatusCodeBadAttributeIdInvalid = 0x80350000;
exports.StatusCodeBadIndexRangeInvalid = 0x80360000;
exports.StatusCodeBadIndexRangeNoData = 0x80370000;
exports.StatusCodeBadDataEncodingInvalid = 0x80380000;
exports.StatusCodeBadDataEncodingUnsupported = 0x80390000;
exports.StatusCodeBadNotReadable = 0x803a0000;
exports.StatusCodeBadNotWritable = 0x803b0000;
exports.StatusCodeBadOutOfRange = 0x803c0000;
exports.StatusCodeBadNotSupported = 0x803d0000;
exports.StatusCodeBadNotFound = 0x803e0000;
exports.StatusCodeBadObjectDeleted = 0x803f0000;
exports.StatusCodeBadNotImplemented = 0x80400000;
exports.StatusCodeBadMonitoringModeInvalid = 0x80410000;
exports.StatusCodeBadMonitoredItemIdInvalid = 0x80420000;
exports.StatusCodeBadMonitoredItemFilterInvalid = 0x80430000;
exports.StatusCodeBadMonitoredItemFilterUnsupported = 0x80440000;
exports.StatusCodeBadFilterNotAllowed = 0x80450000;
exports.StatusCodeBadStructureMissing = 0x80460000;
exports.StatusCodeBadEventFilterInvalid = 0x80470000;
exports.StatusCodeBadContentFilterInvalid = 0x80480000;
exports.StatusCodeBadFilterOperatorInvalid = 0x80c10000;
exports.StatusCodeBadFilterOperatorUnsupported = 0x80c20000;
exports.StatusCodeBadFilterOperandCountMismatch = 0x80c30000;
exports.StatusCodeBadFilterOperandInvalid = 0x80490000;
exports.StatusCodeBadFilterElementInvalid = 0x80c40000;
exports.StatusCodeBadFilterLiteralInvalid = 0x80c50000;
exports.StatusCodeBadContinuationPointInvalid = 0x804a0000;
exports.StatusCodeBadNoContinuationPoints = 0x804b0000;
exports.StatusCodeBadReferenceTypeIdInvalid = 0x804c0000;
exports.StatusCodeBadBrowseDirectionInvalid = 0x804d0000;
exports.StatusCodeBadNodeNotInView = 0x804e0000;
exports.StatusCodeBadNumericOverflow = 0x81120000;
exports.StatusCodeBadServerUriInvalid = 0x804f0000;
exports.StatusCodeBadServerNameMissing = 0x80500000;
exports.StatusCodeBadDiscoveryUrlMissing = 0x80510000;
exports.StatusCodeBadSempahoreFileMissing = 0x80520000;
exports.StatusCodeBadRequestTypeInvalid = 0x80530000;
exports.StatusCodeBadSecurityModeRejected = 0x80540000;
exports.StatusCodeBadSecurityPolicyRejected = 0x80550000;
exports.StatusCodeBadTooManySessions = 0x80560000;
exports.StatusCodeBadUserSignatureInvalid = 0x80570000;
exports.StatusCodeBadApplicationSignatureInvalid = 0x80580000;
exports.StatusCodeBadNoValidCertificates = 0x80590000;
exports.StatusCodeBadIdentityChangeNotSupported = 0x80c60000;
exports.StatusCodeBadRequestCancelledByRequest = 0x805a0000;
exports.StatusCodeBadParentNodeIdInvalid = 0x805b0000;
exports.StatusCodeBadReferenceNotAllowed = 0x805c0000;
exports.StatusCodeBadNodeIdRejected = 0x805d0000;
exports.StatusCodeBadNodeIdExists = 0x805e0000;
exports.StatusCodeBadNodeClassInvalid = 0x805f0000;
exports.StatusCodeBadBrowseNameInvalid = 0x80600000;
exports.StatusCodeBadBrowseNameDuplicated = 0x80610000;
exports.StatusCodeBadNodeAttributesInvalid = 0x80620000;
exports.StatusCodeBadTypeDefinitionInvalid = 0x80630000;
exports.StatusCodeBadSourceNodeIdInvalid = 0x80640000;
exports.StatusCodeBadTargetNodeIdInvalid = 0x80650000;
exports.StatusCodeBadDuplicateReferenceNotAllowed = 0x80660000;
exports.StatusCodeBadInvalidSelfReference = 0x80670000;
exports.StatusCodeBadReferenceLocalOnly = 0x80680000;
exports.StatusCodeBadNoDeleteRights = 0x80690000;
exports.StatusCodeUncertainReferenceNotDeleted = 0x40bc0000;
exports.StatusCodeBadServerIndexInvalid = 0x806a0000;
exports.StatusCodeBadViewIdUnknown = 0x806b0000;
exports.StatusCodeBadViewTimestampInvalid = 0x80c90000;
exports.StatusCodeBadViewParameterMismatch = 0x80ca0000;
exports.StatusCodeBadViewVersionInvalid = 0x80cb0000;
exports.StatusCodeUncertainNotAllNodesAvailable = 0x40c00000;
exports.StatusCodeGoodResultsMayBeIncomplete = 0x00ba0000;
exports.StatusCodeBadNotTypeDefinition = 0x80c80000;
exports.StatusCodeUncertainReferenceOutOfServer = 0x406c0000;
exports.StatusCodeBadTooManyMatches = 0x806d0000;
exports.StatusCodeBadQueryTooComplex = 0x806e0000;
exports.StatusCodeBadNoMatch = 0x806f0000;
exports.StatusCodeBadMaxAgeInvalid = 0x80700000;
exports.StatusCodeBadSecurityModeInsufficient = 0x80e60000;
exports.StatusCodeBadHistoryOperationInvalid = 0x80710000;
exports.StatusCodeBadHistoryOperationUnsupported = 0x80720000;
exports.StatusCodeBadInvalidTimestampArgument = 0x80bd0000;
exports.StatusCodeBadWriteNotSupported = 0x80730000;
exports.StatusCodeBadTypeMismatch = 0x80740000;
exports.StatusCodeBadMethodInvalid = 0x80750000;
exports.StatusCodeBadArgumentsMissing = 0x80760000;
exports.StatusCodeBadNotExecutable = 0x81110000;
exports.StatusCodeBadTooManySubscriptions = 0x80770000;
exports.StatusCodeBadTooManyPublishRequests = 0x80780000;
exports.StatusCodeBadNoSubscription = 0x80790000;
exports.StatusCodeBadSequenceNumberUnknown = 0x807a0000;
exports.StatusCodeBadMessageNotAvailable = 0x807b0000;
exports.StatusCodeBadInsufficientClientProfile = 0x807c0000;
exports.StatusCodeBadStateNotActive = 0x80bf0000;
exports.StatusCodeBadAlreadyExists = 0x81150000;
exports.StatusCodeBadTcpServerTooBusy = 0x807d0000;
exports.StatusCodeBadTcpMessageTypeInvalid = 0x807e0000;
exports.StatusCodeBadTcpSecureChannelUnknown = 0x807f0000;
exports.StatusCodeBadTcpMessageTooLarge = 0x80800000;
exports.StatusCodeBadTcpNotEnoughResources = 0x80810000;
exports.StatusCodeBadTcpInternalError = 0x80820000;
exports.StatusCodeBadTcpEndpointUrlInvalid = 0x80830000;
exports.StatusCodeBadRequestInterrupted = 0x80840000;
exports.StatusCodeBadRequestTimeout = 0x80850000;
exports.StatusCodeBadSecureChannelClosed = 0x80860000;
exports.StatusCodeBadSecureChannelTokenUnknown = 0x80870000;
exports.StatusCodeBadSequenceNumberInvalid = 0x80880000;
exports.StatusCodeBadProtocolVersionUnsupported = 0x80be0000;
exports.StatusCodeBadConfigurationError = 0x80890000;
exports.StatusCodeBadNotConnected = 0x808a0000;
exports.StatusCodeBadDeviceFailure = 0x808b0000;
exports.StatusCodeBadSensorFailure = 0x808c0000;
exports.StatusCodeBadOutOfService = 0x808d0000;
exports.StatusCodeBadDeadbandFilterInvalid = 0x808e0000;
exports.StatusCodeUncertainNoCommunicationLastUsableValue = 0x408f0000;
exports.StatusCodeUncertainLastUsableValue = 0x40900000;
exports.StatusCodeUncertainSubstituteValue = 0x40910000;
exports.StatusCodeUncertainInitialValue = 0x40920000;
exports.StatusCodeUncertainSensorNotAccurate = 0x40930000;
exports.StatusCodeUncertainEngineeringUnitsExceeded = 0x40940000;
exports.StatusCodeUncertainSubNormal = 0x40950000;
exports.StatusCodeGoodLocalOverride = 0x00960000;
exports.StatusCodeBadRefreshInProgress = 0x80970000;
exports.StatusCodeBadConditionAlreadyDisabled = 0x80980000;
exports.StatusCodeBadConditionAlreadyEnabled = 0x80cc0000;
exports.StatusCodeBadConditionDisabled = 0x80990000;
exports.StatusCodeBadEventIdUnknown = 0x809a0000;
exports.StatusCodeBadEventNotAcknowledgeable = 0x80bb0000;
exports.StatusCodeBadDialogNotActive = 0x80cd0000;
exports.StatusCodeBadDialogResponseInvalid = 0x80ce0000;
exports.StatusCodeBadConditionBranchAlreadyAcked = 0x80cf0000;
exports.StatusCodeBadConditionBranchAlreadyConfirmed = 0x80d00000;
exports.StatusCodeBadConditionAlreadyShelved = 0x80d10000;
exports.StatusCodeBadConditionNotShelved = 0x80d20000;
exports.StatusCodeBadShelvingTimeOutOfRange = 0x80d30000;
exports.StatusCodeBadNoData = 0x809b0000;
exports.StatusCodeBadBoundNotFound = 0x80d70000;
exports.StatusCodeBadBoundNotSupported = 0x80d80000;
exports.StatusCodeBadDataLost = 0x809d0000;
exports.StatusCodeBadDataUnavailable = 0x809e0000;
exports.StatusCodeBadEntryExists = 0x809f0000;
exports.StatusCodeBadNoEntryExists = 0x80a00000;
exports.StatusCodeBadTimestampNotSupported = 0x80a10000;
exports.StatusCodeGoodEntryInserted = 0x00a20000;
exports.StatusCodeGoodEntryReplaced = 0x00a30000;
exports.StatusCodeUncertainDataSubNormal = 0x40a40000;
exports.StatusCodeGoodNoData = 0x00a50000;
exports.StatusCodeGoodMoreData = 0x00a60000;
exports.StatusCodeBadAggregateListMismatch = 0x80d40000;
exports.StatusCodeBadAggregateNotSupported = 0x80d50000;
exports.StatusCodeBadAggregateInvalidInputs = 0x80d60000;
exports.StatusCodeBadAggregateConfigurationRejected = 0x80da0000;
exports.StatusCodeGoodDataIgnored = 0x00d90000;
exports.StatusCodeBadRequestNotAllowed = 0x80e40000;
exports.StatusCodeBadRequestNotComplete = 0x81130000;
exports.StatusCodeGoodEdited = 0x00dc0000;
exports.StatusCodeGoodPostActionFailed = 0x00dd0000;
exports.StatusCodeUncertainDominantValueChanged = 0x40de0000;
exports.StatusCodeGoodDependentValueChanged = 0x00e00000;
exports.StatusCodeBadDominantValueChanged = 0x80e10000;
exports.StatusCodeUncertainDependentValueChanged = 0x40e20000;
exports.StatusCodeBadDependentValueChanged = 0x80e30000;
exports.StatusCodeGoodEditedDependentValueChanged = 0x01160000;
exports.StatusCodeGoodEditedDominantValueChanged = 0x01170000;
exports.StatusCodeGoodEditedDominantValueChangedDependentValueChanged = 0x01180000;
exports.StatusCodeBadEditedOutOfRange = 0x81190000;
exports.StatusCodeBadInitialValueOutOfRange = 0x811a0000;
exports.StatusCodeBadOutOfRangeDominantValueChanged = 0x811b0000;
exports.StatusCodeBadEditedOutOfRangeDominantValueChanged = 0x811c0000;
exports.StatusCodeBadOutOfRangeDominantValueChangedDependentValueChanged = 0x811d0000;
exports.StatusCodeBadEditedOutOfRangeDominantValueChangedDependentValueChanged = 0x811e0000;
exports.StatusCodeGoodCommunicationEvent = 0x00a70000;
exports.StatusCodeGoodShutdownEvent = 0x00a80000;
exports.StatusCodeGoodCallAgain = 0x00a90000;
exports.StatusCodeGoodNonCriticalTimeout = 0x00aa0000;
exports.StatusCodeBadInvalidArgument = 0x80ab0000;
exports.StatusCodeBadConnectionRejected = 0x80ac0000;
exports.StatusCodeBadDisconnect = 0x80ad0000;
exports.StatusCodeBadConnectionClosed = 0x80ae0000;
exports.StatusCodeBadInvalidState = 0x80af0000;
exports.StatusCodeBadEndOfStream = 0x80b00000;
exports.StatusCodeBadNoDataAvailable = 0x80b10000;
exports.StatusCodeBadWaitingForResponse = 0x80b20000;
exports.StatusCodeBadOperationAbandoned = 0x80b30000;
exports.StatusCodeBadExpectedStreamToBlock = 0x80b40000;
exports.StatusCodeBadWouldBlock = 0x80b50000;
exports.StatusCodeBadSyntaxError = 0x80b60000;
exports.StatusCodeBadMaxConnectionsReached = 0x80b70000;
